/* eslint-disable @typescript-eslint/naming-convention */
import { is } from '@common/is/is'

import scroll from '@common/scroll/scroll'
import router from '@common/Router/clientRouterFactory'

import DOM from '@common/DOM/DOM'

import { ERouterEvent } from './definitions'

export type TRoute = '/' | '/rolam' | 'gyermekagy' | 'felkeres' | 'ajanlas' | 'kapcsolat'

type TComponentFactory = (props: TAnyObject) => HTMLElement

function changeContent (Component: TComponentFactory, params?: TAnyObject): void {
  const root = document.querySelector('#root')

  if (is.instanceOf(root, HTMLElement)) {
    root.innerHTML = ''

    root.appendChild(
      <Component { ...params } />
    )

    DOM.dispatch(document, ERouterEvent.ContentChanged)
  }

  // Sajnos kell ez a kis delay, különben nem ugrik fel O_o
  window.setTimeout(() => {
    scroll.toTop()
  }, 100)
}

const routes = {
  '/': async (): Promise<void> => {
    const { default: Main } = await import(
      /* webpackChunkName: "Main" */
      './components/Main/Main'
    )

    changeContent(Main)
  },

  '/rolam': async (): Promise<void> => {
    const { default: About } = await import(
      /* webpackChunkName: "About" */
      './components/About/About'
    )

    changeContent(About)
  },

  '/gyermekagy': async (): Promise<void> => {
    const { default: Postpartum } = await import(
      /* webpackChunkName: "Postpartum" */
      './components/Postpartum/Postpartum'
    )

    changeContent(Postpartum)
  },

  '/felkeres': async (): Promise<void> => {
    const { default: Request } = await import(
      /* webpackChunkName: "Request" */
      './components/Request/Request'
    )

    changeContent(Request)
  },

  '/ajanlas': async (): Promise<void> => {
    const { default: Recommendation } = await import(
      /* webpackChunkName: "Recommendation" */
      './components/Recommendation/Recommendation'
    )

    changeContent(Recommendation)
  },

  '/kapcsolat': (): void => {
    scroll.intoView(document.querySelector('#contact') as HTMLElement)
  }
}

function notFound (): void {
  router.push('/')
}

router.init(routes, notFound)

export default router
